import { cn } from '@workspace/ui/lib/utils';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import IllustrationEmptyOrderHistoryImg from '~/assets/img/illustration-empty-order-history.png';

import styles from './NoOrders.module.scss';

interface NoOrdersProps
  extends Omit<React.ComponentPropsWithoutRef<'div'>, 'children'> {
  className?: string;
}

export const NoOrders: React.FC<NoOrdersProps> = ({ className, ...props }) => {
  const { t } = useTranslation();

  return (
    <div {...props} className={cn(styles.container, className)}>
      <img
        className={styles.img}
        src={IllustrationEmptyOrderHistoryImg}
        alt=""
        width="201"
        height="200px"
      />
      <p className={styles.text}>
        <Trans i18nKey="phrases:ordersWillBeHereSoon" t={t} />
      </p>
      <Link to="/shop" className="button _primary">
        {t('goShopping')}
      </Link>
    </div>
  );
};
